<template>
  <div
    id="records"
    class="myusers w-100 p-5"
    :class="[isLoader ? 'f-c-c h-100' : 'f-s-s']"
  >
    <b-spinner
      v-if="isLoader"
      variant="primary"
      type="grow"
      label="Spinning"
    ></b-spinner>
    <div v-else class="accordion w-100" role="tablist">
      <div class="return w-100 f-c-b mb-4">
        <div class="title f-c-c">
          {{ 'ضبط شده های " ' + sessionForRecord.title + ' " ' }}
        </div>
        <div class="f-c-s returnBtn" @click="returnFunc()">
          <div class="returnText f-c-c cp" style="font-size: 90%">برگشت</div>
        </div>
      </div>
      <b-card no-body class="mb-1 mycard" v-for="(v, i) in allSansVal" :key="i">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            class="accordionBtn"
            @click.self="openAccordion('acord' + i, v.id)"
            >{{ v.title }}
            <b-img
              v-if="sessionRoute == 'mySession'"
              @click="showUserModal(v)"
              :src="require(`@/assets/images/gap/user.svg`)"
            ></b-img>
          </b-button>
        </b-card-header>
        <b-collapse :id="'acord' + i" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <ul v-if="recordData && recordData.length" class="mb-3 pl-4 pr-4">
                <li
                  v-for="(v, i) in recordData"
                  :key="i"
                  class="f-c-b mb-3 recordItem"
                >
                  <div class="f-c-c">
                    {{ v.name }}
                  </div>
                  <a :href="v.url" target="_blank">مشاهده</a>
                </li>
              </ul>
              <ul
                v-else
                class="pl-4 pr-4"
                style="
                  list-style: none;
                  text-align: center;
                  margin: 0;
                  font-size: 1.1rem;
                  font-weight: bold;
                "
              >
                <li style="text-shadow: -2px 5px 5px">سانسی وجود ندارد.</li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <b-modal
      id="sans-modal"
      :title="'کاربران' + ' ' + sansSelected.title"
      size="lg"
      button-size="sm"
      :hide-footer="footer"
      ref="user-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <ul v-if="allUser && allUser.length">
          <li v-for="(v, i) in allUser" :key="i" class="f-c-s userItem">
            <b-img
              class="ml-2"
              style="width: 30px"
              :src="require(`@/assets/images/gap/user-blue.svg`)"
            ></b-img>
            <div>
              {{ v.name }}
            </div>
          </li>
        </ul>
        <ul
          v-else
          style="
            padding: 1.5rem 0;
            list-style: none;
            text-align: center;
            margin: 0;
            font-size: 1.1rem;
            font-weight: bold;
          "
        >
          <li style="text-shadow: -2px 5px 5px">کاربری وجود ندارد.</li>
        </ul>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Records",
  data() {
    return {
      isLoader: false,
      footer: true,
      allSansVal: [],
      index: 0,
      recordData: [],
      allUser: [],
      sansSelected: {},
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      allSansRecord: (state) => state.gap.allSansRecord,
      sansRecords: (state) => state.gap.sansRecords,
      sansUser: (state) => state.gap.sansUser,
      sessionForRecord: (state) => state.gap.sessionForRecord,
      sessionRoute: (state) => state.gap.sessionRoute,
    }),
  },
  created() {
    this.isLoader = true;
  },
  methods: {
    ...mapActions("gap", ["getAllSansRecordFunction", "getSansUserFunction"]),
    returnFunc() {
      if (this.sessionRoute == "mySession") {
        this.$router.push({ name: "myMeets" });
      } else {
        this.$router.push({ name: "invitedMeetings" });
      }
    },
    openAccordion(index, id) {
      this.recordData = [];
      if (this.sessionRoute == "mySession") {
        this.getAllSansRecordFunction({
          user_id: this.user.user_id,
          session_sans_id: id,
          routType: "mySession",
        });
      } else {
        this.getAllSansRecordFunction({
          user_id: this.user.user_id,
          session_sans_id: id,
          routType: "invited",
        });
      }
      let allAcord = document.querySelectorAll(".collapse");
      for (let i = 0; i < allAcord.length; i++) {
        allAcord[i].style.display = "none";
      }
      setTimeout(() => {
        document.getElementById(index).style.display = "block";
      }, 100);
    },
    showUserModal(v) {
      this.sansSelected = v;
      this.getSansUserFunction({
        user_id: this.user.user_id,
        session_sans_id: v.id,
      });
    },
  },
  watch: {
    sansRecords(n) {
      if (Object.keys(n).length) {
        if (n.code == 100 && n.contents) {
          this.recordData = n.contents.recording;
        } else {
          this.recordData = [];
        }
      }
    },
    sansUser(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.allUser = n.attendees;
          this.$refs["user-modal"].show();
        } else {
          this.allUser = [];
        }
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.isLoader = false;
    }, 2000);
    this.allSansVal = this.allSansRecord;
    setTimeout(() => {
      document.querySelector(".mycard .accordionBtn").click();
    }, 2000);
  },
};
</script>